<template>
  <div class="px-3 py-2" style="background-color: #131516;">
    <b-overlay :show="showRegistrationOverlay"
               :variant="registerOverlay.variant"
               :opacity="registerOverlay.opacity"
               :blur="registerOverlay.blur"
               :no-wrap="registerOverlay.noWrap"
               :no-center="registerOverlay.noCenter"
               rounded="sm"
    >
      <template #overlay>
        <close-button
            class="position-absolute"
            style="top: 0; right: 0; cursor: pointer"
            @close-button-click="handleRegisterFormOpenClose(false)"
        />
        <b-container
            size="sm"
            style="margin-top: 50px;"
        >
          <registration-form
              :session="session"
              :profile="profile"
          />
        </b-container>
      </template>
      <div>
        <b-container size="sm">
          <b-row style="height:50vh;
                  border-radius: 15px;
                  background-color: #222325;
                  margin-left: 50px;
                  margin-right: 50px;
                  margin-top:75px;
                  padding:15px;
            ">
            <b-col>
              <div style="border-radius: 15px; padding: 0px">
                <b-row
                    style="background-color: #E3EBEDFF;
                    border-radius: 15px;
                    border-bottom: 10px solid #8026ce
                    ">
                  <b-row>
                    <b-col>
                      <div style="height:30vh;">
                        <b-row style="margin-top:5px; margin-left: 50px">
                          <b-col>
                            <h2 style="margin-top: 10px">
                              <b-img v-bind="mainProps"
                                     :src="sessionCompanyLogoURL"
                                     rounded
                                     alt="Rounded image"
                              />

                            </h2>
                          </b-col>
                        </b-row>
                        <b-row style="margin:50px">
                          <b-col cols="9">
                            <h2>{{ sessionTitle }}</h2>
                          </b-col>
                          <b-col>
                            <b-img thumbnail
                                   fluid
                                   :src="sessionImgURL"
                                   :alt="`${sessionTitle} cover image`"
                            />
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                </b-row>
                <b-row style="color: whitesmoke; margin-top: 20px">
                  <b-col cols="9">
                    <h2>{{ sessionTitle }}</h2>

                    <template v-if="sessionCrewHosts.length > 0">
                    <b-avatar-group size="35px">
                      <b-avatar
                          v-for="(aCrewMember, i) in sessionCrewHosts"
                          :src="aCrewMember.imgURL"
                          variant="warning"
                          :key="`crew-${i}`"
                      />
                      <h5 style="margin-left: 10px">
                        Hosted by {{ sessionCrewHostNames() }}
                      </h5>
                    </b-avatar-group>
                    </template>
                  </b-col>
                  <b-col cols="3">
                    <div
                        class="float-right"
                        style="background-color:#383839;
                    border-radius: 15px;
                    text-align: center;
                    padding:10px;
                    width:90px;"
                    >
                      <h6
                          style="background-color: black;
                      border-top-right-radius: 5px;
                      border-top-left-radius: 5px;
                      padding:5px;
                      "
                      >
                        JAN
                      </h6>
                      <h1>9</h1>
                    </div>
                  </b-col>
                </b-row>
                <b-row style="color: whitesmoke;">
                  <b-col>
                    <div>
                      <h6>Tuesday, January 9, 2024 | 1:30 PM to 2:30PM EST</h6>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              <b-row style="margin-top: 15px;
                        height:20vh;
                        border-radius: 15px;
                        background-color: #222325;
                        margin-left: 50px;
                        padding:10px;">
                <b-col style="color:antiquewhite">
                  <div style="background-color:#222325;
               border-radius: 15px;">
                    <h5>
                      <b-icon
                          icon="person-badge"
                          variant="light"
                      />
                      Registration
                    </h5>
                    <hr style="border-color: whitesmoke" />
                    <h5>Welcome! To join the session, please tap the button.</h5>
                    <b-button
                        block
                        @click="handleRegisterFormOpenClose(true)"
                    >
                      Register
                    </b-button>
                  </div>
                </b-col>
              </b-row>
              <b-row style="
      margin-top: 15px;
      height:25vh;
      border-radius: 15px;
      background-color: #222325;
      margin-left: 50px;
      padding:10px;
">
                <b-col style="color:antiquewhite">
                  <div style="background-color:#222325;
               border-radius: 15px;">
                    <h5>
                      <b-icon
                          icon="newspaper"
                          variant="light"
                      />
                      About the Event
                    </h5>
                    <hr style="border-color: whitesmoke" />
                    <tip-tap-output
                        v-if="sessionDescription && Array.isArray(sessionDescription)"
                        :content="sessionDescription"
                        :show-less-char="300"
                        :use-dots="true"
                    />
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="4">
              <b-row style=" margin-top: 15px;
                          height:25vh;
                          border-radius: 15px;
                          background-color: #222325;
                          margin-left: 10px;
                          margin-right: 50px;
                          padding:10px;">
                <b-col style="color:antiquewhite">
                  <div style="background-color:#222325;
                        border-radius: 15px;">
                    <h5>
                      <b-icon
                          icon="people"
                          variant="light"
                      />
                      Hosts
                    </h5>
                    <hr style="border-color: whitesmoke" />
                    <div>
                      <b-row v-for="(aCrewMember, i) in sessionCrewHosts" :key="`host_${i}`">
                        <b-col cols="3">
                          <b-avatar
                              :src="aCrewMember.imgURL"
                              variant="warning"
                              :key="`host-${i}`"
                          />
                        </b-col>
                        <b-col cols="9" class="float-left">
                          {{aCrewMember.name}}
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RegistrationForm from "./registrationForm";
import CloseButton from "@/components/common/closeButton";
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  name: "Sessions_Registration",
  components: {
    RegistrationForm,
    CloseButton,
    TipTapOutput
  },
  props: {
    session: {
      type: Object,
      default: () => {
        return {}
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  mounted() {
    //debugger;
    ///this.sessionCrewHostNames();
  },
  computed: {
    sessionImgURL() {
      return this.session && this.session.session &&
      this.session.session.imgURL ? this.session.session.imgURL : 'https://picsum.photos/500/500/?image=59';
    },
    sessionTitle() {
      return this.session && this.session.session &&
      this.session.session.title ? this.session.session.title : '';
    },
    sessionTopic() {
      return this.session && this.session.session &&
      this.session.session.topic ? this.session.session.topic : '';
    },
    sessionDescription() {
      return this.session && this.session.session &&
      this.session.session.description ? this.session.session.description : '';
    },
    sessionCrewHosts() {
      return this.session && this.session.session && this.session.session.crew &&
      Array.isArray(this.session.session.crew) ?
          this.session.session.crew : [];
    },
    sessionCompanyName() {
      return this.session && this.session.session &&
      this.session.session.companyName ? this.session.session.companyName : null
    },
    sessionCompanyLogoURL(){
      return this.session && this.session.session &&
      this.session.session.companyImgURL ? this.session.session.companyImgURL : null
    }
  },
  methods: {
    handleRegisterFormOpenClose(shallOpen){
      this.showRegistrationOverlay = shallOpen;
    },
    sessionCrewHostNames(){
      if (this.sessionCrewHosts.length > 0) {
          if (this.sessionCrewHosts.length === 1)
            return this.sessionCrewHosts && this.sessionCrewHosts[0] ? this.sessionCrewHosts[0].name : '';
      }
      return "";
    }
  },
  data() {
    return {
      registerOverlay:{
        variant: 'dark',
        opacity:0.95,
        blur:'1rem',
        noWrap: false,
        noCenter:  true
      },
      showRegistrationOverlay: false,
      mainProps: { blank: false, blankColor: '#777', width: 75, height: 75, class: 'm1' }
    };
  }
};
</script>

<style lang="scss" scoped>
.header__close {
  position: relative;
  padding-bottom: 8px;
  &.border-none::after {
    content: none !important;
  }
  .ico {
    position: absolute;
    top: 5px;
    right: 13px;
    cursor: pointer;
  }
  .ico__search {
    right: unset !important;
    left: 13px;
  }
  h3 {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 49px;
    text-align: center;

    color: #5b606c;
  }
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    width: 100%;
    border-bottom: 1px solid #e4e6eb;
  }
}
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-publishing-video {
      width: 0;
    }
    #guide-publishing-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
</style>
